import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export const AIRPORT = "Rhodes Airport (RHO)";

const norm = (s) => (s || "").trim().toLowerCase().replace(/\s+/g, " ");

export function useRoutes() {
  return useQuery({ queryKey: ["routes"], queryFn: async () => (await api.get("/routes")).data });
}

export function matchPrice(routes, pickup, dropoff) {
  const a = norm(pickup);
  const b = norm(dropoff);
  if (!a || !b || a === b) return null;
  const r = (routes || []).find((x) => {
    const o = norm(x.origin);
    const d = norm(x.destination);
    return ((o === a && d === b) || (o === b && d === a)) && x.price != null;
  });
  return r ? r.price : null;
}

export function locationsFrom(routes) {
  const set = new Set([AIRPORT, "Rhodes Port"]);
  (routes || []).forEach((r) => {
    set.add(r.origin);
    set.add(r.destination);
  });
  return [...set];
}
